import type { PageRequest, RepositoryResult } from "../contracts";
import { translateSupabaseError } from "./errors";

export const MAX_PAGE_SIZE = 100;

export function validatePageRequest(page: PageRequest): RepositoryResult<PageRequest> {
  if (!Number.isInteger(page.limit) || page.limit < 1 || page.limit > MAX_PAGE_SIZE) {
    return {
      ok: false,
      error: {
        code: "validation_failure",
        message: `Page limit must be an integer between 1 and ${MAX_PAGE_SIZE}.`,
        retryable: false,
      },
    };
  }
  return { ok: true, value: page };
}

export function mapRepositoryRows<Row, Value>(
  rows: readonly Row[],
  mapper: (row: Row) => RepositoryResult<Value> | Value,
): RepositoryResult<Value[]> {
  const values: Value[] = [];
  for (const row of rows) {
    const mapped = mapper(row);
    if (
      typeof mapped === "object" &&
      mapped !== null &&
      "ok" in mapped &&
      typeof (mapped as { ok?: unknown }).ok === "boolean"
    ) {
      const result = mapped as RepositoryResult<Value>;
      if (!result.ok) return result;
      values.push(result.value);
    } else {
      values.push(mapped as Value);
    }
  }
  return { ok: true, value: values };
}

export async function repositoryAttempt<T>(
  operation: () => Promise<T>,
  fallbackMessage?: string,
): Promise<RepositoryResult<T>> {
  try {
    return { ok: true, value: await operation() };
  } catch (error) {
    return { ok: false, error: translateSupabaseError(error, fallbackMessage) };
  }
}

